import * as actionType from './CommonActionType';

export const updateCommonReducer = (data) => ({
    type: actionType.UPDATE_COMMON_REDUCER,
    payload: data,
});

export const getRolesRequest = (data) => ({
    type: actionType.GET_ROLES_REQUEST,
    payload: data,
});
export const getRolesSuccess = (data) => ({
    type: actionType.GET_ROLES_SUCCESS,
    payload: data,
});
export const getRolesFailure = (error) => ({
    type: actionType.GET_ROLES_FAILURE,
    payload: error,
});

export const getStatusRequest = (data) => ({
    type: actionType.GET_STATUS_REQUEST,
    payload: data,
});
export const getStatusSuccess = (data) => ({
    type: actionType.GET_STATUS_SUCCESS,
    payload: data,
});
export const getStatusFailure = (error) => ({
    type: actionType.GET_STATUS_FAILURE,
    payload: error,
});

export const getDocumentModulesRequest = (data) => ({
    type: actionType.GET_DOCUMENT_MODULES_REQUEST,
    payload: data,
});
export const getDocumentModulesSuccess = (data) => ({
    type: actionType.GET_DOCUMENT_MODULES_SUCCESS,
    payload: data,
});
export const getDocumentModulesFailure = (error) => ({
    type: actionType.GET_DOCUMENT_MODULES_FAILURE,
    payload: error,
});

export const getDocumentTypesRequest = (data) => ({
    type: actionType.GET_DOCUMENT_TYPES_REQUEST,
    payload: data,
});
export const getDocumentTypesSuccess = (data) => ({
    type: actionType.GET_DOCUMENT_TYPES_SUCCESS,
    payload: data,
});
export const getDocumentTypesFailure = (error) => ({
    type: actionType.GET_DOCUMENT_TYPES_FAILURE,
    payload: error,
});

export const getDocumentTypesWithConfigurationRequest = (data) => ({
    type: actionType.GET_DOCUMENT_TYPES_WITH_CONFIGURATION_REQUEST,
    payload: data,
});

    // Classification actions
    export const getClassificationRequest = (data) => ({
        type: actionType.GET_CLASSIFICATION_REQUEST,
        payload: data,
    });
    export const getClassificationSuccess = (data) => ({
        type: actionType.GET_CLASSIFICATION_SUCCESS,
        payload: data,
    });
    export const getClassificationFailure = (error) => ({
        type: actionType.GET_CLASSIFICATION_FAILURE,
        payload: error,
    });
export const getDocumentTypesWithConfigurationSuccess = (data) => ({
    type: actionType.GET_DOCUMENT_TYPES_WITH_CONFIGURATION_SUCCESS,
    payload: data,
});
export const getDocumentTypesWithConfigurationFailure = (error) => ({
    type: actionType.GET_DOCUMENT_TYPES_WITH_CONFIGURATION_FAILURE,
    payload: error,
});
export const getStorageTypesRequest = () => ({
    type: actionType.GET_STORAGE_TYPES_REQUEST,
});

export const getStorageTypesSuccess = (data) => ({
    type: actionType.GET_STORAGE_TYPES_SUCCESS,
    payload: data,
});

export const getStorageTypesFailure = (error) => ({
    type: actionType.GET_STORAGE_TYPES_FAILURE,
    payload: error,
});
export const getCommunicationTypesRequest = (data) => ({
    type: actionType.GET_COMMUNICATION_TYPES_REQUEST,
    payload: data,
});
export const getCommunicationTypesSuccess = (data) => ({
    type: actionType.GET_COMMUNICATION_TYPES_SUCCESS,
    payload: data,
});
export const getCommunicationTypesFailure = (error) => ({
    type: actionType.GET_COMMUNICATION_TYPES_FAILURE,
    payload: error,
});

export const getPriorityTypesRequest = (data) => ({
    type: actionType.GET_PRIORITY_TYPES_REQUEST,
    payload: data,
});
export const getPriorityTypesSuccess = (data) => ({
    type: actionType.GET_PRIORITY_TYPES_SUCCESS,
    payload: data,
});
export const getPriorityTypesFailure = (error) => ({
    type: actionType.GET_PRIORITY_TYPES_FAILURE,
    payload: error,
});

export const getRecipientGroupRequest = (data) => ({
    type: actionType.GET_RECIPIENT_GROUP_REQUEST,
    payload: data,
});
export const getRecipientGroupSuccess = (data) => ({
    type: actionType.GET_RECIPIENT_GROUP_SUCCESS,
    payload: data,
});
export const getRecipientGroupFailure = (error) => ({
    type: actionType.GET_RECIPIENT_GROUP_FAILURE,
    payload: error,
});

export const getUsersForDDRequest = (data) => ({
    type: actionType.GET_USERS_FOR_DD_REQUEST,
    payload: data,
});
export const getUsersForDDSuccess = (data) => ({
    type: actionType.GET_USERS_FOR_DD_SUCCESS,
    payload: data,
});
export const getUsersForDDFailure = (error) => ({
    type: actionType.GET_USERS_FOR_DD_FAILURE,
    payload: error,
});

export const getInvestorsForDDRequest = (data) => ({
    type: actionType.GET_INVESTORS_FOR_DD_REQUEST,
    payload: data,
});
export const getInvestorsForDDSuccess = (data) => ({
    type: actionType.GET_INVESTORS_FOR_DD_SUCCESS,
    payload: data,
});
export const getInvestorsForDDFailure = (error) => ({
    type: actionType.GET_INVESTORS_FOR_DD_FAILURE,
    payload: error,
});

export const getEquityTypeClassRequest = (data) => ({
    type: actionType.GET_EQUITY_TYPE_CLASS_REQUEST,
    payload: data,
});
export const getEquityTypeClassSuccess = (data) => ({
    type: actionType.GET_EQUITY_TYPE_CLASS_SUCCESS,
    payload: data,
});
export const getEquityTypeClassFailure = (error) => ({
    type: actionType.GET_EQUITY_TYPE_CLASS_FAILURE,
    payload: error,
});

export const documentDownloadRequest = (data) => ({
    type: actionType.DOCUMENT_DOWNLOAD_REQUEST,
    payload: data,
});
export const documentDownloadSuccess = (data) => ({
    type: actionType.DOCUMENT_DOWNLOAD_SUCCESS,
    payload: data,
});
export const documentDownloadFailure = (error) => ({
    type: actionType.DOCUMENT_DOWNLOAD_FAILURE,
    payload: error,
});

export const getHoldCoRequest = (data) => ({
    type: actionType.GET_HOLDCO_USER_REQUEST,
    payload: data,
});
export const getHoldCoSuccess = (data) => ({
    type: actionType.GET_HOLDCO_USER_SUCCESS,
    payload: data,
});
export const getHoldCoFailure = (error) => ({
    type: actionType.GET_HOLDCO_USER_FAILURE,
    payload: error,
});

export const getStatusByTypeRequest = (data) => ({
    type: actionType.GET_STATUS_BY_TYPE_REQUEST,
    payload: data,
});
export const getStatusByTypeSuccess = (data) => ({
    type: actionType.GET_STATUS_BY_TYPE_SUCCESS,
    payload: data,
});
export const getStatusByTypeFailure = (error) => ({
    type: actionType.GET_STATUS_BY_TYPE_FAILURE,
    payload: error,
});
// Get User Details
export const getUserDetailsRequest = () => ({
    type: actionType.GET_USER_DETAILS_REQUEST
});

export const getUserDetailsSuccess = (data) => ({
    type: actionType.GET_USER_DETAILS_SUCCESS,
    payload: data
});

export const getUserDetailsFailure = (error) => ({
    type: actionType.GET_USER_DETAILS_FAILURE,
    payload: error
});

// Save Contact Us
export const saveContactUsRequest = (data) => ({
    type: actionType.SAVE_CONTACT_US_REQUEST,
    payload: data
});

export const saveContactUsSuccess = (data) => ({
    type: actionType.SAVE_CONTACT_US_SUCCESS,
    payload: data
});

export const saveContactUsFailure = (error) => ({
    type: actionType.SAVE_CONTACT_US_FAILURE,
    payload: error
});

export const resetContactUsStatus = () => ({
    type: actionType.RESET_CONTACT_US_STATUS
});

export const saveDataUploadCenterRequest = (data) => ({
    type: actionType.SAVE_DATA_UPLOAD_CENTER_REQUEST,
    payload: data,
});
export const saveDataUploadCenterSuccess = (data) => ({
    type: actionType.SAVE_DATA_UPLOAD_CENTER_SUCCESS,
    payload: data,
});
export const saveDataUploadCenterFailure = (error) => ({
    type: actionType.SAVE_DATA_UPLOAD_CENTER_FAILURE,
    payload: error,
});

export const deleteNotificationFileRequest = (payload) => ({
    type: actionType.DELETE_NOTIFICATION_FILE_REQUEST,
    payload,
});
export const deleteNotificationFileSuccess = (data) => ({
    type: actionType.DELETE_NOTIFICATION_FILE_SUCCESS,
    payload: data,
});
export const deleteNotificationFileFailure = (error) => ({
    type: actionType.DELETE_NOTIFICATION_FILE_FAILURE,
    payload: error,
});


// Get Categories for Dropdown
export const getCategoryForDropdownRequest = () => ({
    type: actionType.GET_CATEGORY_FOR_DROPDOWN_REQUEST
});

export const getCategoryForDropdownSuccess = (data) => ({
    type: actionType.GET_CATEGORY_FOR_DROPDOWN_SUCCESS,
    payload: data
});

export const getCategoryForDropdownFailure = (error) => ({
    type: actionType.GET_CATEGORY_FOR_DROPDOWN_FAILURE,
    payload: error
});
